import { DsBossAreaRoutes } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { ChartBarIcon } from '@moia-dev/pace-icons'

export const DsBossAreaNavigationIcon = ChartBarIcon

export const DsBossAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={DsBossAreaRoutes.route}
      Icon={ChartBarIcon}
    />
  )
}
